import { Container } from "react-bootstrap";

import Footer from "../Shared/Footer";
import NavbarSec from "../Shared/NavbarSec";

export default function Layout({ topBannerOffset, children }) {
  return (
    <div style={{ paddingTop: topBannerOffset }}>
      <Container>
        <NavbarSec />
      </Container>
      {children}
      <Footer />
    </div>
  );
}
